import React, { useState, useEffect } from 'react';
import { message, Modal, Breadcrumb, Button } from 'antd';
import { ExclamationCircleOutlined, DashboardOutlined, PlusSquareOutlined } from '@ant-design/icons';
import CategoryTable from '../../components/store/CategoryTable';
import CategoryModal from '../../components/store/CategoryModal';
import { useGetAllCategories, useCreateCategory, useUpdateCategory, useDeleteCategory } from '../../hooks/store/categoryQuery';
import Header from '../../components/dashboard/header';
import { Link } from 'react-router-dom';
import { MdOutlineInventory2, MdOutlineCategory } from 'react-icons/md';

const { confirm } = Modal;

const CategoryPage = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [refreshFlag, setRefreshFlag] = useState(false);

  const { loading, categories } = useGetAllCategories(refreshFlag);
  const createCategory = useCreateCategory();
  const updateCategory = useUpdateCategory();
  const deleteCategory = useDeleteCategory();

  const handleAdd = () => {
    setEditingCategory(null);
    setModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingCategory(record);
    setModalVisible(true);
  };

  const handleDelete = (record) => {
    confirm({
      title: 'Are you sure you want to delete this category?',
      icon: <ExclamationCircleOutlined />,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: async () => {
        try {
          await deleteCategory(record.id);
          message.success('Category deleted successfully');
          setRefreshFlag(!refreshFlag);
        } catch (error) {
          message.error('Failed to delete category');
        }
      },
    });
  };

  const handleSubmit = async (values) => {
    try {
      if (editingCategory) {
        await updateCategory(editingCategory.id, values);
        message.success('Category updated successfully');
      } else {
        await createCategory(values);
        message.success('Category created successfully');
      }
      setModalVisible(false);
      setRefreshFlag(!refreshFlag);
    } catch (error) {
      message.error('Failed to save category');
    }
  };

  return (
    <>
      <div className="main-container">
        <Header />
        <div className="main-body">
          <div className="info-bar">
            <Breadcrumb>
              <Breadcrumb.Item>
                <DashboardOutlined className="dashboard-icon" />
                <Link to={"/dashboard"}>Dashboard</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <MdOutlineInventory2 />
                <Link to={"/dashboard/store"}>Store</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <MdOutlineCategory />
                <Link to="/dashboard/category">Categories</Link>
              </Breadcrumb.Item>
            </Breadcrumb>
            <div style={{ display: 'flex', gap: '1em' }}>
              <Button
                type="primary"
                style={{ backgroundColor: "green", color: "#FFFFFF" }}
                onClick={handleAdd}
                icon={<PlusSquareOutlined />}
              >
                Create Category
              </Button>
            </div>
          </div>
          <div className="table-section">
            <CategoryTable
              categories={categories}
              onEdit={handleEdit}
              onDelete={handleDelete}
              onAdd={handleAdd}
              loading={loading}
            />
          </div>
        </div>
      </div>
      <CategoryModal
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        onSubmit={handleSubmit}
        initialValues={editingCategory}
        title={editingCategory ? 'Edit Category' : 'Add Category'}
        categories={categories}
      />
    </>
  );
};

export default CategoryPage;
